import React from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
const cx = cls(styles);
interface DialProp {
	step: number;
}
export default function Dial(props: DialProp) {
	const step = props.step || 0;
	return (
		<svg className={cx('dial')} width="100%" height="100%" viewBox="0 0 1372 750" xmlns="http://www.w3.org/2000/svg">
			<path
				className={cx('bg')}
				d="
          M130 642
          a534 534 0 1 1 1112 0
        "
				strokeLinecap="round"
				strokeWidth="88"
				stroke="#69c7b0"
				fill="transparent"
			/>
			<path
				className={cx('bar', `step-${step}`)}
				d="
          M130 642
          a534 534 0 1 1 1112 0
        "
				strokeLinecap="round"
				strokeWidth="88"
				stroke="#fdb935"
				fill="transparent"
			/>
		</svg>
	);
}
